import React, { Component } from 'react';

import {__} from "../Translator";

import './Dropdown.css';
import DropdownIcon from './../img/dropdown-arrow-icon.svg';
import InlineSvg from "../InlineSvg";
import AppStore from "../flux/AppStore";
import { randomString } from "../Helpers";
import AppActions from "../flux/AppActions";

class Dropdown extends Component {
  constructor(props) {
    super(props);

    // ID used to uniquely identify the dropdown in the page. We need this to
    // open the correct dropdown using AppActions.openDropdown(...).
    // We handle the open/closed status in the AppStore to assure only one
    // dropdown is open at the time in the page, imitating the native behaviour.
    this.uniqueId = randomString();

    this.state = {
      selected: props.selected,
      buyOnlineLabel: props.buyOnlineLabel
    };

    this.onDropdownOpen = this.onDropdownOpen.bind(this);
    this.onDropdownClose = this.onDropdownClose.bind(this);
  }

  componentDidMount() {
    AppStore.events.openDropdown.addListener(this.onDropdownOpen);
    AppStore.events.closeDropdown.addListener(this.onDropdownClose);
  }

  componentWillUnmount() {
    AppStore.events.openDropdown.removeListener(this.onDropdownOpen);
    AppStore.events.closeDropdown.removeListener(this.onDropdownClose);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ selected: nextProps.selected });
  }

  onDropdownOpen(uniqueId) {
    this.setState({ isVisible: uniqueId === this.uniqueId });
  }

  onDropdownClose(uniqueId) {
    this.setState({ isVisible: false });
  }

  onOptionClick(option) {
    if (this.state.selected !== option.value) {
      this.props.onChange(option.value)
    }

    this.setState({
      selected: option.value,
    });

    AppActions.closeDropdown(this.uniqueId);
  }

  render() {
    const selectedOption = this.props.options.filter(o => o.value === this.state.selected)[0];

    return (
      <div className={`dropdown ${this.props.className}`}>
        {this.props.title ? (
          <div className="dropdown__title">{this.props.title}</div>
        ) : null}

        <div className={`dropdown__option dropdown__selected ${selectedOption && selectedOption.fontClass !== null ? selectedOption.fontClass : null}`} onClick={() => {
          if (this.state.isVisible) {
            AppActions.closeDropdown(this.uniqueId)
          } else {
            AppActions.openDropdown(this.uniqueId)
          }
        }}>
          {selectedOption ? selectedOption.text : this.props.defaultText}
          {this.state.buyOnlineLabel === true && selectedOption && (selectedOption.online_purchase === 1 ?  (<span className="online_purchase_bit">{__('Buy online only')}</span>) :
                  selectedOption.online_purchase === 0 ? '' : (<span className="online_purchase_bit">{__('Buy online available')}</span>))}
          {selectedOption && selectedOption.svg !== null ? <InlineSvg className="dropdown-svg" svg={selectedOption.svg} /> : null}
          {selectedOption && selectedOption.rightIcon !== null ? <div style={{ float: 'right', marginRight: 25, }}>{selectedOption.rightIcon}</div> : null}
          <InlineSvg className="dropdown__arrowDown" svg={DropdownIcon} />
        </div>

        <div className={`dropdown__select ${this.state.isVisible ? 'is-visible' : ''}`}>
          {this.props.options.map(option => {
            return (
              <div
                key={option.value}
                className={`dropdown__option ${option.disabled ? 'disabled' : ''} ${option.fontClass ? option.fontClass : ''} ${this.state.selected === option.value ? 'is-selected' : ''}`}
                onClick={() => this.onOptionClick(option)}
              >
                {option.text}
                {this.state.buyOnlineLabel === true && (option.online_purchase === 1 ?  (<span className="online_purchase_bit">{__('Buy online only')}</span>) :
                  option.online_purchase === 0 ? '' : (<span className="online_purchase_bit">{__('Buy online available')}</span>))}
                {option.svg ? <InlineSvg className="dropdown-svg" svg={option.svg} /> : null}
                {option.rightIcon ? <div style={{ float: 'right', }}>{option.rightIcon}</div> : null}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

/**
 *
 * @type {{className: string, title: null|string, options: null|{value: *, text: string}, selected: null|*, defaultText: string, onChange: function}}
 */
Dropdown.defaultProps = {
  className: '',
  title: null,
  options: null,
  selected: '',
  defaultText: __('...'),
  onChange: console.log,
  svg: null, // @todo 2018-03-14 Should be changed to always be an <svg> element, and inlineSvg should be removed
  rightIcon: null,
  fonts: null,
  online_purchase: false,
};

export default Dropdown;



// WEBPACK FOOTER //
// ./src/components/Dropdown.js